// #TODO 30-04-2018_FG Terminer les interfaces

import {Yii} from "libraries/interfaces/Yii";

// Anguler
import { Component, Input } from '@angular/core';

// Afidium
import { HelperService } from 'libraries/hotel/services/helper.service';

@Component({
    selector: 'remark',
    templateUrl: './remark.component.html'
})
export class RemarkComponent {
    public Yii = Yii;

    private remarksModel;

    @Input()
    public set remarks (value: any) {
        if (value) {
            this.remarksModel = this.helperService.objectToArray(value);
        }
    }

    public get remarks (): any {
        return this.remarksModel;
    }

    constructor (
        private helperService: HelperService
    ) {}

}
